'use client';

import { TbBrandHipchat } from 'react-icons/tb';

const SALES_PREFILL = 'Olá! Tenho um volume maior e gostaria de falar com o time de vendas.';

export function SalesButton() {
  return (
    <button
      type="button"
      className="cta-sales"
      onClick={() => {
        window.dispatchEvent(
          new CustomEvent('trakd:open-chat', { detail: { prefill: SALES_PREFILL } }),
        );
      }}
    >
      <TbBrandHipchat size={18} strokeWidth={1.8} />
      Falar com vendas
    </button>
  );
}
